export default __webpack_public_path__ + "static/media/NeueMontreal-MediumItalic.262438e4.otf";